import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'components';
import { useTimer } from 'hooks';
import {
  resendVerificationSmsStart,
  validateSmsVerificationCodeStart,
} from 'redux/user/user.actions';
import { setVerificationCodeTimerStatus } from 'redux/app/app.actions';
import styles from './MobileVerificationModal.module.scss';
import useTranslation from 'hooks/useTranslation';

const CODE_VALID_LENGTH = 4;

const MobileVerificationModal = ({ onValidate, show, onClose, mobile }) => {
  const { verificationCodeTimer, isTimerStarted } = useTimer();
  const dispatch = useDispatch();

  const [verificationCode, setVerificationCode] = useState('');
  const isValidVerificationCodeLength =
    verificationCode?.length === CODE_VALID_LENGTH;

  const { getTranslation, getAppLocale } = useTranslation('COMMON');
  const { t } = getTranslation();

  const locale = getAppLocale();

  const getMessage = (locale) => {
    if (locale === 'en') {
      return <>Please enter 4 digit code sent to {mobile} mobile number.</>;
    }

    return (
      <>
        لطفا کد ۴ رقمی ارسال شده به شماره‌ موبایل‌
        <span className={styles.mobile_number}> {mobile} </span>
        را وارد نمایید.
      </>
    );
  };

  const onSuccessfullyVerifyCode = () => {
    dispatch(setVerificationCodeTimerStatus(false));
    onValidate({ mobile, verificationCode });
    onClose && onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isValidVerificationCodeLength) return;

    dispatch(
      validateSmsVerificationCodeStart({
        mobile,
        verificationCode,
        onSuccess: onSuccessfullyVerifyCode,
      })
    );
  };

  const handleChange = (e) => {
    const { value, maxLength } = e.target;

    setVerificationCode(value.slice(0, maxLength));
  };

  const handleResend = (e) => {
    e.preventDefault();

    if (isTimerStarted) return false;
    dispatch(resendVerificationSmsStart(mobile));
  };

  const handleToggle = (e) => {
    if (e) e.preventDefault();

    dispatch(setVerificationCodeTimerStatus(false));

    onClose && onClose();
  };

  useEffect(() => {
    if (show && !isTimerStarted) {
      setVerificationCode('');
      dispatch(setVerificationCodeTimerStatus(true));
    }
  }, [show]);

  return (
    <Modal visible={show} className={styles.verificationModal}>
      <form onSubmit={handleSubmit} noValidate>
        <ModalHeader title={t('MOBILE_VERIFICATION_MODAL').TITLE} />
        <ModalBody>
          <p className={styles.description}>{getMessage(locale)}</p>
          <div className='form_control flex'>
            <input
              name='verificationCode'
              value={verificationCode}
              onChange={handleChange}
              className={styles.verificationCodeInut}
              type='number'
              placeholder={t('MOBILE_VERIFICATION_MODAL').CODE_PLACEHOLDER}
              id='verifyPhone'
              maxLength={CODE_VALID_LENGTH}
              autoFocus
            />
          </div>
          <div className={styles.resendWrapper}>
            {t('MOBILE_VERIFICATION_MODAL').NOT_RECIEVED}
            <a
              href={isTimerStarted ? null : '#/'}
              onClick={handleResend}
              className={clsx(isTimerStarted && styles.disabled)}
            >
              {t('MOBILE_VERIFICATION_MODAL').TRY_AGAIN}
            </a>
            <span className={styles.timer}>{verificationCodeTimer}</span>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className='modal__container__footer__left'>
            <a href='#/' onClick={handleToggle} className='btn btn-tertiary'>
              {t('CANCEL_BTN_DEFAULT')}
            </a>
            <input
              type='submit'
              value={t('USER_INFO_MOBILE_VERIFY_SUBMIT')}
              className={`${styles.submit_btn} ${clsx('btn ml-1', {
                'btn-primary': isValidVerificationCodeLength,
                'btn-primary-disabled': !isValidVerificationCodeLength,
              })}`}
            />
          </div>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default MobileVerificationModal;
